import type {} from "@lit/react";
import { DrawerToggle as DrawerToggleElement, } from "@vaadin/app-layout/vaadin-drawer-toggle.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DrawerToggleElement, };
export type DrawerToggleEventMap = Readonly<{}>;
const events = {} as DrawerToggleEventMap;
export type DrawerToggleProps = WebComponentProps<DrawerToggleElement, DrawerToggleEventMap>;
export const DrawerToggle = createComponent({
    elementClass: DrawerToggleElement, events, react: React, tagName: "vaadin-drawer-toggle"
});
